import { useQuery } from "@tanstack/react-query";
import omit from "lodash/omit";
import { Profile, QueryOptions } from "PFTypes";

import { PotentialWarningsResponse } from "../../../services/api";
import { FetchPotentialWarnings, fetchPotentialWarnings } from "./fetch_potential_warnings";
import { potentialWarningsKeys, QueryKeyParams } from "./query_keys";

export const usePotentialWarningsQuery = (
  params: FetchPotentialWarnings,
  options?: QueryOptions<PotentialWarningsResponse, { response: any; statusText: string; code: string }>
) => {
  const {
    bookings,
    activityId,
    bookingType,
    workforceMember,
    globalCategory,
    globalOverridesDiaryTime,
    globalOverridesNonWorkingTime
  } = params.values;

  const queryKeyParams: QueryKeyParams = {
    bookingsData: (bookings ?? []).map((booking) => omit(booking, "title", "description")),
    activityId,
    workforceMemberId: (workforceMember as Profile)?.id,
    bookingType,
    globalCategoryId: globalCategory?.id,
    globalOverridesDiaryTime,
    globalOverridesNonWorkingTime
  };

  return useQuery<PotentialWarningsResponse, { response: any; statusText: string; code: string }>({
    queryKey: potentialWarningsKeys.single(queryKeyParams),
    queryFn: () =>
      fetchPotentialWarnings({
        values: params.values,
        mode: params.mode,
        initialBookings: params.initialBookings
      }),
    ...options
  });
};
